module.exports = __webpack_public_path__ + "static/media/truck_location.f549bd5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tiendas/carouselPropositions/truck_location.png
// module id = 2184
// module chunks = 0